import React from 'react';

import { backendApi } from '../../../api/backendClient';
import PaginatedTaskSection from './PaginatedTaskSection';

const TaskHistoryPage = ({
    role = 'employee',
    token = '',
    hydrateTask,
    refreshSignal = 0,
    renderTask,
}) => {
    const isEmployee = role === 'employee';
    const fetchTasks = isEmployee
        ? backendApi.getEmployeeTasks
        : backendApi.getCompanyTasks;

    return (
        <div className="w-full space-y-6 pb-10">
            <div>
                <h1 className="text-2xl font-bold tracking-tight text-zinc-900 dark:text-white">
                    History
                </h1>
                <p className="mt-1 text-sm text-zinc-600 dark:text-zinc-400">
                    {isEmployee
                        ? 'Tasks you finished or where payment was collected.'
                        : 'Company tasks that are completed or have released payment.'}
                </p>
            </div>

            <PaginatedTaskSection
                token={token}
                fetchTasks={fetchTasks}
                scope="history"
                hydrateTask={hydrateTask}
                refreshSignal={refreshSignal}
                title={isEmployee ? 'Completed assignments' : 'Completed company tasks'}
                description="Approved and released tasks only, newest first."
                emptyMessage={
                    isEmployee
                        ? 'No completed tasks yet. Finished work will appear here after payment is released.'
                        : 'No completed tasks yet. Released payouts will appear here.'
                }
                renderTask={renderTask}
                showStatusFilter={false}
                framed
            />
        </div>
    );
};

export default TaskHistoryPage;
